import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.6667 6.33333H3.33333C2.78105 6.33333 2.33333 5.88562 2.33333 5.33333V4.04085C2.33333 3.61687 2.6007 3.23897 3.00051 3.09786L7.33436 1.56827C7.7651 1.41624 8.2349 1.41624 8.66564 1.56827L12.9995 3.09786C13.3993 3.23897 13.6667 3.61687 13.6667 4.04085V5.33333C13.6667 5.88562 13.219 6.33333 12.6667 6.33333Z",
      stroke: "currentColor",
      "stroke-width": "1.3",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M3.48333 6.33333V11.6667M5.81667 6.33333V11.6667M8.15 6.33333V11.6667M10.4833 6.33333V11.6667M12.8167 6.33333V11.6667",
      stroke: "currentColor",
      "stroke-width": "1.3"
    }, null, -1),
    _createElementVNode("path", {
      d: "M2.33333 14V13C2.33333 12.4477 2.78105 12 3.33333 12H12.6667C13.219 12 13.6667 12.4477 13.6667 13V14",
      stroke: "currentColor",
      "stroke-width": "1.3",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M1.31667 14.0167H14.6833",
      stroke: "currentColor",
      "stroke-width": "1.3",
      "stroke-linecap": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }